import './HowItWorksSection.css';

const steps = [
  {
    number: '1',
    icon: '✍️',
    title: 'Sign Up',
    description: 'Create your account in 30 seconds. No credit card required to start.',
  },
  {
    number: '2',
    icon: '🦀',
    title: 'Create Your OpenClaw',
    description: 'Configure your OpenClaw instance with your preferred settings. Takes about 2 minutes.',
  },
  {
    number: '3',
    icon: '💬',
    title: 'Start Chatting',
    description: 'Your agent is ready! Start chatting, coding, or automating tasks.',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="landing-section how-it-works-section">
      <div className="landing-section-inner">
        <div className="section-header animate-on-scroll">
          <h2 className="section-title">Get Started in Minutes</h2>
          <p className="section-subtitle">
            From signup to your first OpenClaw conversation in under 3 minutes
          </p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className={`step-card animate-on-scroll animate-delay-${index + 1}`}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>

              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <svg viewBox="0 0 100 20" preserveAspectRatio="none">
                    <path
                      d="M0,10 Q50,0 100,10"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeDasharray="5,5"
                    />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
